export default {
  pageTitle: "Expense Categories",
  pageDescription:
    "Manage the categories used to classify expenses. System categories are pre-configured defaults that can be renamed but not deleted.",
  columnName: "Name",
  columnDeductible: "Tax Deductible %",
  columnStatus: "Status",
  active: "Active",
  archived: "Archived",
  system: "System",
  createButton: "New Category",
  createTitle: "Create Expense Category",
  editTitle: "Edit Expense Category",
  name: "Name",
  deductiblePercent: "Tax Deductible %",
  archiveAction: "Archive",
  unarchiveAction: "Unarchive",
  deleteAction: "Delete",
  deleteConfirmTitle: "Delete Category",
  deleteConfirmMessage:
    "Are you sure you want to delete this category? This cannot be undone.",
  deleteSuccess: "Category deleted successfully",
  archiveConfirmTitle: "Archive Category",
  archiveConfirmMessage:
    "Are you sure you want to archive this category? It will no longer appear in the expense form.",
  loading: "Loading...",
  emptyTitle: "No expense categories",
  emptyMessage: "Create a custom category to get started.",
  createSuccess: "Category created successfully",
  updateSuccess: "Category updated successfully",
  archiveSuccess: "Category archived successfully",
  unarchiveSuccess: "Category unarchived successfully",
};
